<template>
  <div class="articleView container">
    <div class="ab">
      <div class="view container">
        <article-title/>
        <div class="ai">
          <img src="http://video.naolamp.com/images/index/article_title.png"/>
        </div>
        <div class="ad">
          <div class="indexData">
            <div class="articleItem">
              <div v-for="article in dataLst" :key="article.articleId" class="item container">
                <router-link :to="{name: 'articleDetail',params: {articleId:article.articleId}}">
                  <div class="itemImg" v-bind:style="{backgroundImage:'url(' + (article.frontImage || 'http://video.naolamp.com/bbs_front/1529041405718.jpg') + ')',
                  backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
                  </div>
                </router-link>
                <div class="itemRight">
                  <div class="itemTab container">
                    <span :class="article.tab">{{article.tab | articleTabFilter}}</span>
                  </div>
                  <div class="itemTitle">
                    <router-link :to="{name: 'articleDetail',params: {articleId:article.articleId}}">
                      <span :class="article.articleWay">{{article.articleWay | articleWayFilter}}</span><span style="display: inline-block" v-if="article.articleWay === 'Y'">&nbsp;|&nbsp;</span>{{article.title}}
                    </router-link>
                  </div>
                  <div class="itemSummary">
                    <div>{{article.summary}}</div>
                  </div>
                  <div class="itemData">
                    <div class="itemAuthor">
                      <router-link :to="{name: 'anotherHome',params: {userId:article.userId}}">
                        <img :src="article.headImg || defaultHead"/>
                        <span>{{article.userName}}</span>
                      </router-link>
                      <div>{{article.createTime | formatTime}}</div>
                    </div>
                    <div class="itemFoot">
                      <div class="itemCount">
                        <span><i class="iconfont icon-browse"></i>&nbsp;{{article.visitCount | maxNumFix(999)}}</span>
                        <span><i class="iconfont icon-comments"></i>&nbsp;{{article.replyCount | maxNumFix(99)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="MoreShow" class="loadMore" @click="getDataLst">加载更多</div>
            </div>
          </div>
          <div class="dataRight right">
            <div class="r_fun">
              <router-link to="/article/editor">
                <div><i class="iconfont icon-editor"></i>我要发帖</div>
              </router-link>
            </div>
            <div class="topUser" v-if="userLst">
              <div class="title">车灯社区认证车灯师</div>
              <div class="list">
                <div v-for="us in userLst" :key="us.userId" class="us">
                  <div class="head">
                    <router-link :to="{name: 'anotherHome',params: {userId:us.userId}}">
                      <img :src="us.headImg || defaultHead"/>
                    </router-link>
                  </div>
                  <div class="info">
                    <router-link :to="{name: 'anotherHome',params: {userId:us.userId}}">
                      <div>{{us.userName}}<img :src="v1"/></div>
                    </router-link>
                    <span>积分：{{us.score}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="topArticle">
              <div class="title">热门帖子</div>
              <div class="list">
                <div v-for="at in articleLst" :key="at.articleId" class="ai">
                  <router-link :to="{name: 'articleDetail',params: {articleId:at.articleId}}">
                    <div class="tab" :class="at.tab">{{at.tab | articleTabFilter}}</div>
                    <div class="articleT">{{at.title}}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import articleTitle from '../common/articleTitle.vue'
import loading from '../common/loading.vue'
export default {
  name: 'userMain',
  data () {
    return {
      MoreShow: false,
      tabSearchH: '',
      searchIcon: require('../../assets/icon/search_icom.png'),
      v1: require('../../assets/icon/V1.png'),
      msg: '个人首页',
      isLoad: true,
      page: 0,
      pageSize: 5,
      totalPages: 10,
      defaultHead: require('../../assets/image/installer.png'),
      dataTitleVal: 'new',
      tabSearch: '',
      contentSearch: '',
      dataTitleTab: [{
        'name': '最新发布',
        'code': 'new'
      }, {
        'name': '热门推荐',
        'code': 'hand'
      }, {
        'name': '热门评论',
        'code': 'eval'
      }],
      dataLst: [{
        'summary': '加载中...',
        'createTime': 1528969629000,
        'handCount': 999,
        'replyCount': 999,
        'tab': 'D32,奥迪,',
        'good': 'N',
        'articleId': 5,
        'lastReplyTime': 1528969629000,
        'open': 'Y',
        'title': '常用车灯用语你懂多少',
        'headImg': null,
        'isRelease': 'Y',
        'userId': '402888c563f7211f0163f721b2d10000',
        'visitCount': 999,
        'userName': '用户9569',
        'articleWay': 'Y',
        'frontImage': 'http://video.naolamp.com/bbs_front/1528969629659.png',
        'top': 'N'
      }],
      articleLst: [{
        'summary': '如图所示，在车辆的仪表盘上有一个带有红色三角形的按钮，按下去即可开启双闪。',
        'createTime': 1529041512000,
        'handCount': 1,
        'replyCount': 8,
        'tab': 'CP_AL',
        'good': 'N',
        'articleId': 11,
        'lastReplyTime': 1529056420000,
        'open': 'Y',
        'title': '双闪灯使用',
        'headImg': null,
        'isRelease': 'Y',
        'userId': '402888c563f7211f0163f721b2d10000',
        'visitCount': 81,
        'userName': '用户9569',
        'articleWay': 'Z',
        'frontImage': 'http://video.naolamp.com/bbs_front/1529041512278.jpg',
        'top': 'N'
      }],
      userLst: [{
        'userId': '402888c563f7211f0163f721b2d10000',
        'userPhone': '15902059569',
        'passWord': '0A1BAB267B4603F4',
        'accesstoken': '5fda383f-44ca-4e38-9068-69e5b3a8988f',
        'userName': '用户9569',
        'articleNum': 14,
        'focusNum': 0,
        'score': 90,
        'comeWay': 'WX',
        'headImg': null,
        'createTime': 1528859570000,
        'lastLoginTime': 1532333754000
      }]
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getParams()
    this.getDataLst()
    this.init()
  },
  methods: {
    init: function () {
      this.isLoad = true
      let that = this
      that.axios.post('count/articleIndex', {
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          that.articleLst = res.articleLst
          that.userLst = res.userLst
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    searchClick: function () {
    },
    contentChange: function (k) {
      this.tabSearch = ''
      this.contentSearch = k
    },
    tabChange: function (k) {
      this.contentSearch = ''
      this.tabSearch = k
    },
    getParams () {
      // 取到路由带过来的参数
      let obj = this.$route.params
      // 将数据放在当前组件的数据内
      if (obj.tabSearch) {
        this.tabSearch = obj.tabSearch
      }
      if (obj.contentSearch) {
        this.contentSearch = obj.contentSearch
      }
    },
    titleClick: function (tab) {
      let up = false
      for (let i = 0; i < this.dataTitleTab.length; i++) {
        if (tab === this.dataTitleTab[i].code) {
          this.dataTitleVal = this.dataTitleTab[i].code
          up = true
        }
      }
      if (up) {
        this.getDataLst()
      }
    },
    'updateDataPage': function (p) {
      this.page = p
      this.getDataLst()
    },
    'getDataLst': function () {
      this.isLoad = true
      let that = this
      that.page = that.page + 1
      that.axios.post('topic/list', {
        orderBy: that.dataTitleVal,
        page: that.page,
        tab: that.tabSearch,
        content: that.contentSearch,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          if (that.page === 1) {
            that.dataLst = res.dataLst
          } else {
            that.dataLst = that.dataLst.concat(res.dataLst)
          }
          if (res.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {
    articleTabFilter: function (e) {
      if (e === 'DG_AL') {
        return '灯改案例'
      } else {
        return '产品案例'
      }
    }
  },
  components: {
    articleTitle,
    loading
  },
  watch: {
    // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
    'tabSearch': function () {
      this.getDataLst()
    },
    'contentSearch': function () {
      this.getDataLst()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleView {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
}
.articleView .view {
  width: 1200px;
  margin: 0 auto;
}
.view .ad {
  margin-top: 20px;
}
.indexData {
  float: left;
  width: 850px;
  background-color: #FFFFFF;
  margin-bottom: 50px;
}
.item {
  margin: 0 20px;
  padding: 20px 0;
  width: 810px;
  text-align: left;
  border-bottom: 1px solid #E3E3E3;
}
.item .itemImg {
  margin-right: 30px;
  width: 370px;
  height: 230px;
  float: left;
}
.itemRight {
  width: 410px;
  float: left;
}
.itemRight .itemTab {
  padding: 10px 0;
  width: 410px;
}
.DG_AL {
  background-color: #05B570;
}
.CP_AL {
  background-color: #efbb41;
}
.itemRight .itemTab span {
  display: inline-block;
  /*padding: 0 12px;*/
  color: #FFFFFF;
  line-height: 28px;
  font-size: 16px;
  height: 28px;
  width: 83px;
  text-align: center;
}
.itemTitle {
  margin-bottom: 20px;
  color: #333333;
  width: 410px;
  font-size: 18px;
}
.itemTitle:hover {
  color: #6b6b6b;
}
.itemTitle .Z {
  background-color: #959eca;
  padding: 2px;
  color: white;
  font-size: 15px;
  display: none;
}
.itemTitle .Y {
  /*background-color: #05B570;*/
  padding: 2px;
  color: #05B570;
  font-size: 18px;
}
.itemSummary {
  line-height: 26px;
  height: 80px;
  font-size: 14px;
  color: #000000;
  overflow:hidden;
  text-overflow:ellipsis;
}
.itemData {
  padding: 20px 0;
}
.itemAuthor {
  color: #999;
  font-size: 12px;
}
.itemAuthor img {
  float: left;
  border-radius: 50%;
  height: 30px;
}
.itemAuthor span {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  color: #000000;
}
.topUser .us .info div:hover,.itemAuthor span:hover {
  color: #6b6b6b;
}
.itemAuthor div {
  float: left;
  height: 30px;
  line-height: 30px;
}
.itemCount {
  float: right;
  display: flex;
  align-items: center;
  text-align: right;
  margin-top: 5px;
}
.icon-browse,
.icon-comments{
  font-size: 18px;
}
.itemCount span {
  display: flex;
  align-items: center;
  padding-right: 15px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  font-size: 14px;
  box-sizing: border-box;
}
.loadMore {
  font-size: 20px;
  line-height: 50px;
  margin: 30px auto;
  width: 280px;
  height: 50px;
  background-color: #05B570;
  color: #FFFFFF;
  cursor: pointer;
}
.dataRight {
  margin-left: 10px;
}
.r_fun {
  background-color: #FFFFFF;
  width: 340px;
  height: 90px;
}
.r_fun div{
  margin: 20px 30px;
  font-size: 20px;
  line-height: 50px;
  float: left;
  width: 280px;
  height: 50px;
  background-color: #05B570;
  color: white;
  border-radius: 2px;
}
.r_fun .iconfont {
  font-size: 25px;
  height: 50px;
  line-height: 50px;
  padding-right: 15px;
}
.topUser {
  margin-top: 10px;
  background-color: #FFFFFF;
  text-align: left;
}
.topUser .title,.topArticle .title {
  padding: 26px 0 10px 23px;
  font-size: 20px;
  color: #333333;
  font-family: FZYH_510M;
}
.topUser .us {
  padding: 10px 23px;
}
.topUser .us .head {
  float: left;
  padding-right: 25px;
}
.topUser .us .head img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.topUser .us .info img {
  margin-left: 10px;
}
.topUser .us .info div {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
  font-family: "SourceHanSansCN-Medium";
  font-weight: bold;
  color: #333333;
}
.topUser .us .info span{
  font-size: 14px;
}
.topArticle {
  margin-top: 10px;
  background-color: #FFFFFF;
  text-align: left;
  padding-bottom: 20px;
}
.topArticle .ai {
  padding: 10px 23px;
}
.topArticle .tab {
  float: left;
  text-align: center;
  color: #FFFFFF;
  font-size: 16px;
  width: 83px;
  height: 28px;
  line-height: 28px;
  margin-right: 20px;
}
.topArticle .articleT {
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #000000;
  width: 180px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.topArticle .articleT:hover{
  color: #6b6b6b;
}
</style>



// WEBPACK FOOTER //
// src/components/article/articleList.vue